import { render, staticRenderFns } from "./ServerDown.vue?vue&type=template&id=8e557e40&scoped=true&"
import script from "./ServerDown.vue?vue&type=script&lang=js&"
export * from "./ServerDown.vue?vue&type=script&lang=js&"
import style0 from "./ServerDown.vue?vue&type=style&index=0&id=8e557e40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e557e40",
  null
  
)

export default component.exports